import { render, staticRenderFns } from "./ItemProfileGroupEditor.vue?vue&type=template&id=1e8fbbd4&scoped=true"
import script from "./ItemProfileGroupEditor.vue?vue&type=script&lang=js"
export * from "./ItemProfileGroupEditor.vue?vue&type=script&lang=js"
import style0 from "./ItemProfileGroupEditor.vue?vue&type=style&index=0&id=1e8fbbd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8fbbd4",
  null
  
)

export default component.exports